import { TRichTextEditorFormat } from './models';
import { findIndex } from 'lodash';
import { AnyType } from '@src/models/common';

export const convertToQuillFormat = (format: TRichTextEditorFormat): string => {
  switch (format) {
    case 'h2':
    case 'h3':
    case 'h4':
      return 'header';

    case 'bold':
      return 'bold';

    case 'link':
      return 'link';

    case 'listBullet':
      return 'bullet';

    case 'listOrdered':
      return 'list';

    case 'showMoreHr':
      // Это наш кастомный обработчик.
      // Заведен в utils тулбара
      return 'hr';
  }
};

export const initRegisterPlugins = async () => {
  if (typeof window === 'undefined') return;

  // @ts-ignore
  const { default: module } = await import('react-quill');
  const Quill = module?.Quill;
  const Embed = Quill?.import('blots/block/embed');

  class Hr extends Embed {
    static create(value: AnyType) {
      return super.create(value);
    }
  }

  Hr.blotName = 'hr';
  Hr.className = 'delimiter';
  Hr.tagName = 'hr';

  Quill?.register({
    'formats/hr': Hr,
  });
};

export const showMoreHrHandler = function () {
  if (typeof window === 'undefined') return;

  // @ts-ignore
  const quill: typeof Quill = this.quill;
  const contents: AnyType = quill.getContents();
  const idx = findIndex(contents.ops, (o: AnyType) => o?.insert?.hr);
  const range = quill.getSelection();
  if (range?.index && idx < 0) {
    quill.insertEmbed(range.index, 'hr', 'null');
    quill.setSelection(range.index + 2);
  }
};
